import Link from 'next/link';

import css from '../sass/sitestyle.scss';

const Sidebar = (props) => (
  <aside className={css.left}>
    <p className={css.eyebrow}>Leaderboard</p>
    <h2>Top burgers</h2>
    <ol className={css['sidebar-list']}>
      {(props.topBurgers || []).slice(0, 6).map((burger, index) => (
        <li key={burger.burgerID}>
          <span className={css['sidebar-rank']}>{index + 1}</span>
          <Link
            as={`/b/${burger.burgerID}`}
            href={`/burger?id=${burger.burgerID}`}
          >
            <a>
              <span>{burger.burgerName}</span>
              <strong>{burger.burgerScore}</strong>
            </a>
          </Link>
        </li>
      ))}
    </ol>
  </aside>
);

export default Sidebar;



// WEBPACK FOOTER //
// components/Sidebar.js